// extracted by mini-css-extract-plugin
export default {"paginate":"Pagination_paginate__WrmQ0"};